$( document ).ready(() => {

	$('#sub-hero-gallery').modal();

	$('#sub-hero-video-button')
		.on('click', function () {
			var video = new Plyr('#sub-hero-video .subhero')
			console.log( video );
			video.on( 'ready', function() { console.log( 'Ready', video ); video.play(); } );
		});
});



// WEBPACK FOOTER //
// ./assets/js/components/layout/sub-hero.js